import i18n from "i18next";

export default (key:string, data?: any):string => {
    const t = i18n.t
    if (typeof t === 'function')
        return t(key, data);
    return '';
}
